import { Injectable } from '@angular/core';
import { facadeFactory } from '@spartacus/core';
import { Observable } from 'rxjs';
import { AssignedShipTo, AvailableShipTosSearchParams, Pagination } from '../../../core/model';
import { AvailableShipTosSearchParamsState, SOLD_TO_CORE_FEATURE } from '../store/sold-to-state';

@Injectable({
  providedIn: 'root',
  useFactory: () =>
    facadeFactory({
      facade: AvailableShipTosFacade,
      feature: SOLD_TO_CORE_FEATURE,
      async: true,
      methods: [
        'searchForAvailableShipTos',
        'getAvailableShipTos',
        'getAvailableShipTosLoading',
        'getAvailableShipTosPagination',
        'getSearchParametersForAvailableShipTos',
        'updateSearchParametersForAvailableShipTos',
      ],
    }),
})
export abstract class AvailableShipTosFacade {
  abstract searchForAvailableShipTos(searchParams: AvailableShipTosSearchParams): void;

  abstract getAvailableShipTos(): Observable<Array<AssignedShipTo>>;

  abstract getAvailableShipTosLoading(): Observable<boolean>;

  abstract getAvailableShipTosPagination(): Observable<Pagination | undefined>;

  abstract getSearchParametersForAvailableShipTos(key: string, userUid?: string): Observable<AvailableShipTosSearchParamsState>;

  abstract updateSearchParametersForAvailableShipTos(searchParams: AvailableShipTosSearchParams): void;
}
